<template>
  <span v-if="position.order?.uid" class="p-d-flex p-ai-center">
    <router-link :to="{ path: `/orders/${position.order.uid}` }"
                 :target="settings.openAllLinksInSameTab ? '_self' : '_blank'"
                 rel="noopener"
                 draggable="false">
      <Button class="p-button-text p-p-1" v-tooltip.top="position.order?.number ? position.order.number : null">
        <i class="ti-hummer"/>
      </Button>
    </router-link>
  </span>
  <i v-else class="ti-minus"/>
</template>
<script>
import settings from "@/settings";
export default {
  name: 'OpenOrderButton',
  props: {
    position: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      settings
    }
  },
}
</script>

<!--<style scoped lang="scss">-->

<!--</style>-->